import { useEffect, useState } from "react";
import { IState, ReduxMap } from "../../redux/redux";
import { ISchoolAffiliateList } from "./schoolTypes";
import { Server, ServerResponse } from "../../utils/Server";
import StoreX, { store } from "../../redux/oldStore";
import { toast } from "react-toastify";
import Button from "../_Core/Button";


interface IProps extends IState {
    
}


const SchoolAffiliationList = (props:IProps) => {
    const [data, setData] = useState<ISchoolAffiliateList>();
    

    useEffect(() => {
        init();
    },[]);

    const init = () => {
        store.server.getApi<ServerResponse<ISchoolAffiliateList>>("../SchoolAffiliate/List")
        .then(x=>{
            if(x.Success){
                setData(x.Value);
            } else {
                console.log("Error",x.Message);
                toast.error(x.Message);
            }
        });
    };

    const generateParticipationInvoices = ()=>{
        if(!window.confirm("Are you sure you want to generate participation invoices?")) return;

        store.server.getApi<ServerResponse<any>>("../SchoolAffiliate/CreateParticipationInvoices")
        .then(x=>{
            if(x.Success){
                toast.success("Invoices generated successfully");
                init();
            } else {
                console.log("Error",x.Message);
                toast.error(x.Message);
            }
        });
    };

    const ResetAffiliationRecords = ()=>{
        if(!window.confirm("Are you sure you want to reset Affiliation Records? \r\nThis should only be done once a season, in prep for a new season. This will lock all open affilation records and creat new ones resetting status, and estimates.")) return;

        let tempSeason = `${((new Date()).getFullYear())} - ${((new Date()).getFullYear()+1)}`;
        let season = window.prompt("Enter the season year for the new affiliation records", tempSeason);

        if(!season) return;

        store.server.postApi<ServerResponse<any>>("../SchoolAffiliate/ResetAffiliationRecords", {newSeason: season})
        .then(x=>{
            if(x.Success){
                toast.success("Affiliation records reset successfully");
                init();
            } else {
                console.log("Error",x.Message);
                toast.error(x.Message);
            }
        });
    };


    return (<>
        <div className="flex-between">
            <h2>School Affiliations</h2>            
            <div>
                <Button onClick={init} type="refresh" iconOnly={true} />
                <Button onClick={generateParticipationInvoices} type="open" text="Generate Participation Invoices" />
                <Button onClick={ResetAffiliationRecords} type="copy" text="Reset Affiliation Records" />
            </div>
        </div>

        { data && <div className="school-affiliation-list item-list">
            {data.affiliates.map((x,i) => {
                const school = data.schoolsDic[x.SchoolId+''];
                return <div key={i} className="item">
                    <strong>{school ?? 'Unknown school'}</strong>
                    {x.Status && <div>Status: {x.Status}</div>}
                    <div><a href={StoreX.BuildUrlWithFair(`../app/school/affiliate/${x.SchoolId}`)} target="_blank"> Affiliate Record</a></div>
                    <div>{data.invoices?.filter(f=>f.affiliateId === x.Id)?.map((r,ri)=>{
                        return <div key={ri}>$ {r.invoiceTotal.toFixed(2)} <a href={StoreX.BuildUrlWithFair(`../purchase/getinvoice/${r.invoiceId}`)} target="_blank"> Invoice</a> Memo: {r.memo}</div>
                    })}</div>
                </div>
            })}
        </div>}
    </>);
};

export default ReduxMap(SchoolAffiliationList);